import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/useAuthStore';
import { useInitializeApp } from './hooks/useInitializeApp';
import { LandingPage } from './components/public/LandingPage';
import { WhyMenioo } from './components/public/WhyMenioo';
import { TermsOfService } from './components/public/TermsOfService';
import { PrivacyPolicy } from './components/public/PrivacyPolicy';
import { PricingPage } from './components/public/PricingPage';
import { ScrollToTop } from './components/common/ScrollToTop';

export function App() {
  useInitializeApp();

  const isLoading = useAuthStore((state) => state.isLoading);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Main landing page */}
      <Route path="/" element={<LandingPage />} />
      
      {/* Info pages */}
      <Route path="/why-menioo" element={<WhyMenioo />} />
      
      {/* Legal pages */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      
      {/* Pricing page */}
      <Route path="/pricing" element={<PricingPage />} />
      
      <Route path="/cookies" element={<Navigate to="/privacy" replace />} />
      
      <Route path="/about" element={
        <div className="min-h-screen bg-menioo-cream">
          <Navigate to="/" />
        </div>
      } />
      
      <Route path="/contact" element={
        <div className="min-h-screen bg-menioo-cream">
          <Navigate to="/" />
        </div>
      } />
      
      <Route path="/blog" element={
        <div className="min-h-screen bg-menioo-cream">
          <Navigate to="/" />
        </div>
      } />
      
      {/* Fallback for any other routes */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
    </>
  );
}